
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Erika wurde kurz nach der Geburt ihres ersten Kalbes erneut besamt,
sie verbringt ihr Leben eigentlich nun in permanenter Schwangerschaft.
Wiederum 285 Tage später bringt sie ihr zweites Kalb zur Welt, das ihr
sogleich nach der Geburt weggenommen wird. Erika ist nun eine Zweitmelkkuh.
Pro Kalb wird sie im Durchschnitt 305 Tage am Stück gemolken – immer
zweimal täglich. Wenn sie jeweils hochträchtig ist, wird Erika «galt gestellt»,
man gönnt ihr eine Melkpause von bis zu acht Wochen bis zur nächsten Geburt.`}</p>
    <Image file={[require('images/laktationszyklus-01.svg'), require('images/laktationszyklus-02.svg')]} title='Das typische Jahr einer Milchkuh' subtitle=' ' source='Quelle: www.landschafftleben.at' mdxType="Image" />
    <p>{`Erika ist besonders schön, sie hat ein gutes Fundament, wie Landwirte sagen,
eine schöne Rückenlinie, ein tiefes Euter, und sie besticht durch ihre Zitzenstellung.
An einer Viehschau wird sie Schönheitskönigin. Dafür wurden Erikas Zitzen mit
Kollodium-Kleber versiegelt. Tierärzte sagen, in mehreren Schichten aufgetragen,
wirke er gleich wie ein Sekundenkleber. Das Parlament hat vor einem Monat abgelehnt,
das Verkleben der Zitzen zu verbieten. Schmerzhaft für die Tiere ist zudem, dass sie
für ein pralles Euter an diesem Tag weniger gemolken werden. Erika ist begehrt.
Als einwandfreie Milchkuh wird sie für 3200 Franken verkauft und auf einen anderen Bauernhof verfrachtet.`}</p>
    <Image file={[require('images/viehschau-01.svg'), require('images/viehschau-02.svg')]} title='Zusammensetzung der Gesamtnote bei einer Viehschau' subtitle='' source='' mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;